import React, { useCallback } from 'react';
import { useMutation } from '@apollo/client';

import { DeleteBrandMutation } from 'src/gql/server-side/mutations-hg';
import { events, linkMultiple } from 'src/modules/analyticsTracker';
import type { BrandListItem } from 'src/types';
import DeleteBrandModalContent from './DeleteBrandModalContent';
import pick from 'lodash/pick';
import { getRefetchBrandListQuery } from 'src/components/screens/ListBrands';

interface Props {
  brand: BrandListItem;
  isOpen: boolean;
  onClose: () => void;
}

const DeleteBrandModal = ({ brand, isOpen, onClose }: Props) => {
  const deleteBrand = useCallback(
    (mutate) => () => {
      linkMultiple(
        [events.DELETE_BRAND_CONFIRMATION_CLICKED, events.LOGO_DELETED],
        events.DELETE_BRAND_CONFIRMATION_CLICKED,
      );
      mutate({
        variables: {
          id: brand.id,
          owner: pick(brand.owner, ['id', 'type']),
        },
      });
      onClose();
    },
    [brand, onClose],
  );

  const [mutate, { loading, error }] = useMutation(DeleteBrandMutation, {
    onCompleted: getRefetchBrandListQuery(),
  });

  return (
    <DeleteBrandModalContent
      loading={loading}
      error={error}
      isOpen={isOpen}
      onSuccess={deleteBrand(mutate)}
      onClose={onClose}
    />
  );
};

export default DeleteBrandModal;
